module.exports = {"441322001":"罗阳街道","441322002":"龙溪街道","441322100":"石坝镇","441322102":"麻陂镇","441322103":"观音阁镇","441322104":"公庄镇","441322105":"杨村镇","441322106":"柏塘镇","441322108":"泰美镇","441322113":"湖镇镇","441322115":"长宁镇","441322116":"福田镇","441322117":"龙华镇","441322119":"园洲镇","441322121":"石湾镇","441322122":"杨侨镇","441322123":"横河镇","441322570":"罗浮山管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/441322.json
// module id = 2147
// module chunks = 0